import { UserManagerSettings } from "oidc-client-ts";

export type DefaultTheme = {
    "base-color"?: string;
    "logo-image"?: string;
    "login-logo-image"?: string;
    "login-background-color"?: string;
};

export type PasswordStrength = {
    minimum_length?: number;
    required_lowercase_chars?: number;
    required_uppercase_chars?: number;
    required_numbers?: number;
    required_special_chars?: number;
};

export type AppSchemas = {
    rest: Record<string, any>;
    resources: Record<string, ResourceSchema>;
};

export type Feature = "totp" | "ldap" | "rememberMe";

export type Features = {
    [key in Feature]: boolean;
};

declare global {
    interface Window {
        schemas: AppSchemas;
        userLanguage: string;
        userData: {
            userId: string;
            userSub: string;
            promptForPasswordChange: boolean;
            passwordChangeRequired: boolean;
        };
        identityProvider: string; /// type of the identity provider
        defaultTheme: DefaultTheme;
        publicLogoUrl: string;
        publicBackgroundColor: string;
        selfClientId: string;
        oidcClientSettings: UserManagerSettings;
        passwordStrength: PasswordStrength;
        features: Features;
    }
}

export class LocalStorageSchema {
    beforeLoginUrl: string = null; /// url before starting the login process
}

export type FieldTypeSchema = {
    name: string;
    options?: any;
    // these are only defined for relations
    type?: "ONETOMANY" | "MANYTOONE";
    target?: string;
    options_depends_on?: {
        name: string;
        identifier: string;
    };
};

export type FieldValidator = {
    name: string;
    key: string;
    params: any;
};

export type FieldSchema = {
    type: FieldTypeSchema;
    name: string;
    required: boolean;
    default?: any;
    validators: FieldValidator[];
};

export type ResourceSchema = Record<string, FieldSchema>;
